<script>
  export let fill="#233E43";
</script>

<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.54297 14.6279V12.6279H13.543V14.6279H5.54297ZM13.543 7.62793L9.54297 11.6279L5.54297 7.62793H8.04297V4.62793H11.043V7.62793H13.543ZM2.54297 0.62793H16.543C17.653 0.62793 18.543 1.52793 18.543 2.62793V16.6279C18.543 17.7379 17.653 18.6279 16.543 18.6279H2.54297C1.44297 18.6279 0.542969 17.7379 0.542969 16.6279V2.62793C0.542969 1.52793 1.44297 0.62793 2.54297 0.62793ZM2.54297 2.62793V16.6279H16.543V2.62793H2.54297Z" fill={fill}/>
</svg>
